import { isNilOrEmpty } from '@@serverHelpers/index.mjs';
import { find, propEq, propOr } from 'ramda';
import { BankAccountPeriodEnum } from '@fasstech/oip-core/entities/BankAccount/enums';

export const booleanOptions = [
  {
    value: true,
    label: 'Oui'
  },
  {
    value: false,
    label: 'Non'
  }
];

export const civilityOptions = [
  {
    value: 'MISTER',
    label: 'Monsieur'
  },
  {
    value: 'MISS',
    label: 'Madame'
  }
];

export const attachedToOptions = [
  {
    value: 'ADHERENT_PRINCIPAL',
    label: 'Adhérent principal',
    granteeTypes: ['CHILD', 'SPOUSE']
  },
  {
    value: 'EN_NOM_PROPRE',
    label: 'En nom propre',
    granteeTypes: ['CHILD', 'SPOUSE']
  },
  {
    value: 'AUTRE',
    label: 'Autre',
    granteeTypes: ['CHILD', 'SPOUSE']
  },
  {
    value: 'CONJOINT',
    label: 'Conjoint',
    granteeTypes: ['CHILD'],
    needsSpouse: true
  },
  {
    value: 'ADHERENT_PRINCIPAL_ET_CONJOINT',
    label: 'Adhérent principal et conjoint',
    granteeTypes: ['CHILD'],
    needsSpouse: true
  },
  {
    value: 'ADHERENT_PRINCIPAL_ET_AUTRE',
    label: 'Adhérent principal et autre',
    granteeTypes: ['CHILD']
  }
];

export const paymentFrequencyExtendedOptions = [
  {
    value: BankAccountPeriodEnum.MONTHLY,
    label: 'Paiement mensuel'
  },
  {
    value: BankAccountPeriodEnum.QUARTERLY,
    label: 'Paiement trimestriel'
  },
  {
    value: BankAccountPeriodEnum.BIANNUAL,
    label: 'Paiement semestriel'
  },
  {
    value: BankAccountPeriodEnum.ANNUAL,
    label: 'Paiement annuel'
  }
];

export const getLabelFromValue = (value, options) => {
  if (isNilOrEmpty(value)) {
    return '-';
  }

  return propOr('-', 'label', find(propEq('value', value))(options));
};

export const getCaisseFromValue = (value, options) => {
  if (isNilOrEmpty(value)) {
    return '-';
  }

  return propOr('-', 'caisse', find(propEq('value', value))(options));
};

export default booleanOptions;
